export var TradevestTaxEntityType;
(function (TradevestTaxEntityType) {
    TradevestTaxEntityType["NATURAL_PERSON"] = "NATURAL_PERSON";
    TradevestTaxEntityType["LEGAL_ENTITY"] = "LEGAL_ENTITY";
    TradevestTaxEntityType["JOINT_PERSON"] = "JOINT_PERSON";
    TradevestTaxEntityType["BENEFICIAL_OWNER"] = "BENEFICIAL_OWNER";
    TradevestTaxEntityType["LEGAL_REPRESENTATIVE"] = "LEGAL_REPRESENTATIVE";
})(TradevestTaxEntityType || (TradevestTaxEntityType = {}));
export var TradevestFsaType;
(function (TradevestFsaType) {
    TradevestFsaType["INDIVIDUAL"] = "INDIVIDUAL";
    TradevestFsaType["JOINT"] = "JOINT";
})(TradevestFsaType || (TradevestFsaType = {}));
export var TradevestTaxExemptionOrderStatus;
(function (TradevestTaxExemptionOrderStatus) {
    TradevestTaxExemptionOrderStatus["RECEIVED"] = "RECEIVED";
    TradevestTaxExemptionOrderStatus["INVALID"] = "INVALID";
    TradevestTaxExemptionOrderStatus["ACTIVE"] = "ACTIVE";
    TradevestTaxExemptionOrderStatus["INACTIVE"] = "INACTIVE";
})(TradevestTaxExemptionOrderStatus || (TradevestTaxExemptionOrderStatus = {}));
export const FSA_MAX_AMOUNT = {
    [TradevestFsaType.INDIVIDUAL]: 1000,
    [TradevestFsaType.JOINT]: 2000,
};
export const TRADEVEST_FSA_SUPPORTED_TYPES = [TradevestFsaType.INDIVIDUAL];
export const TRADEVEST_FSA_MAX_AMOUNT = 1000;
export function effectiveFsaMaxAmount(fsaType) {
    return Math.min(FSA_MAX_AMOUNT[fsaType], TRADEVEST_FSA_MAX_AMOUNT);
}
export function isFsaTypeSupportedByTradevest(fsaType) {
    return TRADEVEST_FSA_SUPPORTED_TYPES.includes(fsaType);
}
export function fsaCancellationValidUntil(usedFsa, currentYear) {
    return usedFsa > 0 ? `${currentYear}-12-31` : `${currentYear - 1}-12-31`;
}
export function toFreistellungsauftragSummary(order, rejection) {
    return {
        taxExemptionOrderId: order.taxExemptionOrderId,
        status: order.status,
        fsaType: order.fsaType,
        fsaAmount: order.fsaAmount,
        fsaMaxAmount: effectiveFsaMaxAmount(order.fsaType),
        validFrom: order.fsaValidFrom,
        validUntil: order.fsaValidUntil,
        createdOn: order.createdOn,
        modifiedOn: order.modifiedOn,
        rejection,
    };
}
export function emptyTaxInformation(taxYear) {
    return {
        taxYear,
        lossPotEquities: 0,
        lossPotGeneral: 0,
        incomeCoveredEquities: 0,
        incomeCoveredGeneral: 0,
        usedFsa: 0,
        withheldCapitalGainsTax: 0,
        withheldSolidarityTax: 0,
        withheldChurchTax: 0,
        creditedForeignWithholdingTax: 0,
    };
}
//# sourceMappingURL=tradevest-taxes.types.js.map